/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://8081.localport.dealer.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 51);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = PropTypes;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setClassNames = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Filters undefined, null or empty strings from a list of comma separated items, joins them and returns a string
 * Returns null if 'classes' is empty
 * @param {object} classes - An arguments object
 */
var setClassNames = function setClassNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var classList = new Set(classes);
  return _toConsumableArray(classList).filter(function (c) {
    return c;
  }).join(' ') || null;
};

exports.setClassNames = setClassNames;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_WIDGET_INFO = exports.SET_HOVER = void 0;
var SET_HOVER = 'SET_HOVER';
exports.SET_HOVER = SET_HOVER;
var SET_WIDGET_INFO = 'SET_WIDGET_INFO';
exports.SET_WIDGET_INFO = SET_WIDGET_INFO;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Common", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.Common;
  }
});
Object.defineProperty(exports, "CommonTester", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.CommonTester;
  }
});
Object.defineProperty(exports, "createStore", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.createStore;
  }
});

var _wsmCommonData = __webpack_require__(47);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _format = __webpack_require__(7);

var _background = __webpack_require__(25);

var _images = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Background =
/*#__PURE__*/
function (_Component) {
  _inherits(Background, _Component);

  function Background(props) {
    var _this;

    _classCallCheck(this, Background);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Background).call(this, props));
    _this.imageRef = _react.default.createRef();
    _this.state = {
      backgroundImage: '//static.dealer.com/images/blank.gif'
    };
    return _this;
  }

  _createClass(Background, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var image = this.imageRef.current;

      if (image && image.complete) {
        this.updateBackgroundImage();
      }
    }
  }, {
    key: "updateBackgroundImage",
    value: function updateBackgroundImage() {
      this.setState({
        backgroundImage: this.imageRef.current.currentSrc || this.imageRef.current.src
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showImage = _this$props.showImage,
          imageLocation = _this$props.imageLocation,
          imageUrl = _this$props.imageUrl,
          imagePosition = _this$props.imagePosition,
          imageSize = _this$props.imageSize,
          backgroundColor = _this$props.backgroundColor,
          backgroundGradient = _this$props.backgroundGradient,
          backgroundRepeat = _this$props.backgroundRepeat,
          backgroundTransitionProperty = _this$props.backgroundTransitionProperty,
          backgroundTransitionTimingFunction = _this$props.backgroundTransitionTimingFunction,
          backgroundTransitionDuration = _this$props.backgroundTransitionDuration,
          foregroundImageCircle = _this$props.foregroundImageCircle,
          foregroundImageHeight = _this$props.foregroundImageHeight,
          foregroundImageWidth = _this$props.foregroundImageWidth,
          foregroundImageMargin = _this$props.foregroundImageMargin,
          foregroundImagePadding = _this$props.foregroundImagePadding,
          foregroundImageAlignment = _this$props.foregroundImageAlignment;
      var backgroundImage = this.state.backgroundImage;
      var hasBackground = showImage === false && imageLocation !== 'foreground' && (backgroundColor !== '' || backgroundGradient !== '');
      var hasResponsiveImage = (0, _images.isResponsiveImageType)(imageUrl, imageLocation);
      var responsiveImageUrl = "".concat(imageUrl).concat((0, _format.setParamSeparator)(imageUrl), "impolicy=downsize_bkpt");

      if (showImage || hasBackground) {
        return _react.default.createElement("div", {
          className: (0, _background.setBackgroundClassNames)(imageLocation, foregroundImageCircle, foregroundImageMargin, foregroundImagePadding, foregroundImageAlignment, backgroundColor, backgroundTransitionProperty, backgroundTransitionTimingFunction, backgroundTransitionDuration),
          style: (0, _background.setBackgroundStyles)(showImage, imageLocation, imageUrl, imagePosition, imageSize, backgroundGradient, backgroundRepeat, foregroundImageHeight, foregroundImageWidth, hasResponsiveImage, backgroundImage)
        }, hasResponsiveImage && _react.default.createElement("img", {
          ref: this.imageRef,
          alt: "",
          hidden: true,
          role: "presentation",
          className: "responsive-image d-none",
          src: "".concat(responsiveImageUrl, "&w=2000"),
          sizes: " (min-width: 769px) and (max-width: 1280px) 1280px, (min-width: 1281px) and (max-width: 1600px) 1600px, (min-width: 1601px) 2000px, 768px",
          srcSet: "\n\t\t\t\t\t\t\t\t".concat(responsiveImageUrl, "&w=1280 1280w,\n\t\t\t\t\t\t\t\t").concat(responsiveImageUrl, "&w=1600 1600w,\n\t\t\t\t\t\t\t\t").concat(responsiveImageUrl, "&w=2000 2000w,\n\t\t\t\t\t\t\t\t").concat(responsiveImageUrl, "&w=768 768w"),
          onLoad: this.updateBackgroundImage.bind(this)
        }));
      }

      return null;
    }
  }]);

  return Background;
}(_react.Component);

Background.defaultProps = {
  imageLocation: '',
  imageUrl: '',
  imagePosition: '',
  imageSize: '',
  backgroundColor: '',
  backgroundGradient: '',
  backgroundRepeat: '',
  backgroundTransitionProperty: '',
  backgroundTransitionTimingFunction: '',
  backgroundTransitionDuration: '',
  foregroundImageCircle: false,
  foregroundImageHeight: 0,
  foregroundImageWidth: 0,
  foregroundImageMargin: '',
  foregroundImagePadding: '',
  foregroundImageAlignment: ''
};
Background.propTypes = {
  showImage: _propTypes.default.bool.isRequired,
  imageLocation: _propTypes.default.string,
  imageUrl: _propTypes.default.string,
  imagePosition: _propTypes.default.string,
  imageSize: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  backgroundGradient: _propTypes.default.string,
  backgroundRepeat: _propTypes.default.string,
  backgroundTransitionProperty: _propTypes.default.string,
  backgroundTransitionTimingFunction: _propTypes.default.string,
  backgroundTransitionDuration: _propTypes.default.string,
  foregroundImageCircle: _propTypes.default.bool,
  foregroundImageHeight: _propTypes.default.number,
  foregroundImageWidth: _propTypes.default.number,
  foregroundImageMargin: _propTypes.default.string,
  foregroundImagePadding: _propTypes.default.string,
  foregroundImageAlignment: _propTypes.default.string
};
var _default = Background;
exports.default = _default;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerTrackingEvent = void 0;

var _trackEvent = __webpack_require__(30);

/**
 * Sets the event object for the Google anlytics event
 * Passes the object to the `trackGoogleAnalyticsEvent` helper function
 * @param {string} element - A string value for element
 * @param {string} elementCTA - A string value for elementCTA
 * @param {string} result - A string value for result
 * @param {string} windowId - A string value for windowId
 */
var triggerTrackingEvent = function triggerTrackingEvent(element, elementCTA, result, windowId) {
  var eventData = {
    element: element,
    elementCTA: elementCTA,
    result: result,
    windowId: windowId
  };
  var _global = global,
      window = _global.window;
  return (0, _trackEvent.trackGoogleAnalyticsEvent)(eventData, window);
};

exports.triggerTrackingEvent = triggerTrackingEvent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setParamSeparator = void 0;

/**
 * Sets the correct URL param separator based on existence of `?`
 * @param {string} url - A string value to be checked for existing param separators
 */
var setParamSeparator = function setParamSeparator(url) {
  return url && url.includes('?') ? '&' : '?';
};

exports.setParamSeparator = setParamSeparator;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setImageDimension = exports.hasImpolicy = exports.isDealerImage = void 0;

/**
 * Determines if a specific URL matches conditional checks
 * Returns a boolean that checks for specific Dealer.com image URLs
 * @param {string} url - A URL string value
 */
var isDealerImage = function isDealerImage(url) {
  var domainRegex = /(.*\/\/.*)?(pictures|images|static)(\.)([^.]+\.)?dealer\.com(.*)/;
  return domainRegex.test(url);
};
/**
 * Determines if a specific URL contains our `impolicy` URL parameter
 * Returns a boolean that checks for impolicy param
 * @param {string} imageUrl - A URL string value
 */


exports.isDealerImage = isDealerImage;

var hasImpolicy = function hasImpolicy(imageUrl) {
  return imageUrl ? imageUrl.includes('impolicy') : false;
};
/**
 * Sets the proper image dimension based on if it should be equal height and width
 * Returns an image dimension integer value based on the `dimensionType`
 * @param {string} dimensionType - A string value of 'height' or 'width'
 * @param {string} deviceType - A string value of 'DESKTOP' or 'MOBILE' to set appropriate fallback values
 * @param {integer} height - A number value setting the height
 * @param {integer} width - A number value setting the width
 * @param {boolean} isEqualDimensions - A boolean determining if the dimensions should be equal
 */


exports.hasImpolicy = hasImpolicy;

var setImageDimension = function setImageDimension() {
  var dimensionType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'width';
  var deviceType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DESKTOP';
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var isEqualDimensions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var imageDimension = dimensionType.toLowerCase().trim() === 'width' ? width : height;

  if (isEqualDimensions) {
    if (!height && width || width && height !== width) {
      imageDimension = width;
    } else if (!width && height) {
      imageDimension = height;
    } else if (height !== width || width === 0 && height === 0) {
      imageDimension = deviceType === 'DESKTOP' ? 192 : 160;
    }
  }

  return imageDimension;
};

exports.setImageDimension = setImageDimension;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setImageUrl = exports.isResponsiveImageType = exports.isResizable = void 0;

var _format = __webpack_require__(7);

var _images = __webpack_require__(8);

/**
 * Determines that image URL meets criteria for resize adjustments
 * Returns a boolean that checks for dealer.com image domain and no impolicy param included
 * @param {string} imageUrl - A URL string value
 */
var isResizable = function isResizable(imageUrl) {
  return (0, _images.isDealerImage)(imageUrl) && !(0, _images.hasImpolicy)(imageUrl);
};
/**
 * Determines if image URL and image location allow responsive image
 * Returns a boolean that checks `imageLocation` and if it should be resizable
 * @param {string} imageUrl - A URL string value
 * @param {string} imageLocation - A string value for defining foreground param configuraiton
 */


exports.isResizable = isResizable;

var isResponsiveImageType = function isResponsiveImageType(imageUrl, imageLocation) {
  return imageLocation !== 'foreground' && isResizable(imageUrl);
};
/**
 * Formats url of the imageUrl based on height and width parameters
 * Returns resized image URL
 * @param {string} imageUrl - A URL string value
 * @param {number} imageHeight - A number value for height
 * @param {number} imageWidth - A number value for width
 * @param {string} imageLocation - A string value for defining foreground param configuraiton
 */


exports.isResponsiveImageType = isResponsiveImageType;

var setImageUrl = function setImageUrl(imageUrl, imageHeight, imageWidth, imageLocation) {
  if (imageLocation === 'foreground' && isResizable(imageUrl)) {
    var resizeMethod = imageHeight && imageWidth ? 'downsize_crop' : 'downsize'; // 'impolicy' parameter triggers Akamai resizing

    var resizedImage = "".concat(imageUrl).concat((0, _format.setParamSeparator)(imageUrl), "impolicy=").concat(resizeMethod); // Resized dimension allows high pixel dense devices to display better quality

    var resizedHeight = imageHeight * 3;
    var resizedWidth = imageWidth * 3;

    if (!imageHeight && !imageWidth) {
      resizedImage = "".concat(resizedImage, "&w=2000");
    } else {
      if (imageHeight) {
        resizedImage = "".concat(resizedImage, "&h=").concat(resizedHeight);
      }

      if (imageWidth) {
        resizedImage = "".concat(resizedImage, "&w=").concat(resizedWidth);
      }
    }

    return resizedImage;
  } else if (imageUrl) {
    return imageUrl;
  }

  return null;
};

exports.setImageUrl = setImageUrl;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = ReactRedux;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(48);

var _reactHotLoader = __webpack_require__(41);

var _Widget = _interopRequireDefault(__webpack_require__(19));

var _store = __webpack_require__(38);

var _widgetComponents = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * WARNING: This file is owned by ws-scripts and can not be edited!
 *
 * This is the main entry point for our application when
 * executed in the browser. As such, it has some responsibilities:
 *
 * - Load server side rendered redux state
 * - Create the redux store with that state
 * - Kick off a React hydrate bound to the redux store
 * - Set up hot reloading
 *
 * NOTE: The eslint-disable-lines are needed because this file won't lint
 * when it's in the ws-scripts repo because those files only exist in the
 * widget. It's safe because the entire application won't work if those
 * weren't really resolved. It would be really apparent quickly.
 *
 * We load our server side rendered state from an object
 * of the form:
 *
 *	window.DDC = {
 *		WS: {
 *			state: {
 *				"ws-hours": {
 *					"hours1": {STATE}
 *					"hours2": {STATE}
 *				},
 *				"ws-quick-specs": {
 *					"quick-specs1": {STATE}
 *				}
 *			}
 *		}
 *	};
 *
 * In local development, the state will be a JSON object. When
 * loaded from CMS, it will be a string, since that reduces
 * serialization overhead but still avoids string concatenation.
 */
// eslint-disable-line import/no-unresolved
var getFlag = function getFlag(name, defaultValue) {
  if (!window.DDC || !window.DDC.Flags) {
    return defaultValue;
  }

  return window.DDC.Flags[name];
};

var serveBundleFromClientSite = getFlag('serve-osiris-bundle-from-clientsite', false) === true;
var stateParentKey = serveBundleFromClientSite ? 'WS' : 'OSIRIS';

var getWidgetStatesByType = function getWidgetStatesByType(widgetName) {
  if (!window.DDC || !window.DDC[stateParentKey] || !window.DDC[stateParentKey].state || !window.DDC[stateParentKey].state[widgetName]) {
    return {};
  }

  return window.DDC[stateParentKey].state[widgetName];
};

var getWidgetState = function getWidgetState(widgetStates, widgetId) {
  var preloadedState = widgetStates[widgetId];

  if (typeof preloadedState === 'string') {
    preloadedState = JSON.parse(preloadedState);
  }

  return preloadedState;
};

var renderWidget = function renderWidget(WidgetComponent, renderFunc, store, widgetId) {
  renderFunc(_react.default.createElement(_reactHotLoader.AppContainer, null, (0, _widgetComponents.getWidgetComponents)(WidgetComponent, store, widgetId)), document.getElementById("".concat(widgetId, "-app-root")));
};

var widgetIdToStore = {};

var initializeWidgets = function initializeWidgets() {
  var widgetStates = getWidgetStatesByType('ws-content-cta');
  var widgetIds = Object.keys(widgetStates);
  widgetIds.forEach(function (widgetId) {
    var store = (0, _store.createStore)(getWidgetState(widgetStates, widgetId));
    widgetIdToStore[widgetId] = store;
    renderWidget(_Widget.default, _reactDom.hydrate, store, widgetId); // We've initialized. We don't need to keep this data around anymore.
    // Deleting it ensures that we don't accidentally reinitialize later.

    if (serveBundleFromClientSite) {
      delete widgetStates[widgetId];
    }
  });
};

if (serveBundleFromClientSite) {
  initializeWidgets();
} else if (window.DDC && window.DDC.Events && window.DDC.Events['inline-js-available']) {
  initializeWidgets();
} else {
  $(document).on('inlineJSAvailable', initializeWidgets);
}

if (false) {
  module.hot.accept('../containers/Widget', function () {
    Object.keys(widgetIdToStore).forEach(function (widgetId) {
      var store = widgetIdToStore[widgetId];

      var ReloadedWidget = require('../containers/Widget').default; // eslint-disable-line import/no-unresolved


      renderWidget(ReloadedWidget, _reactDom.render, store, widgetId);
    });
  });
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHover = setHover;

var _types = __webpack_require__(3);

function setHover() {
  var isHovered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    type: _types.SET_HOVER,
    payload: {
      isHovered: isHovered
    }
  };
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classes = __webpack_require__(2);

var _analytics = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleClick = function handleClick(event, isClickableDivElement, element, elementCTA, result, windowId) {
  // Disable event to allow clickable wrapper to apply window.location
  if (isClickableDivElement) {
    event.preventDefault();
  }

  (0, _analytics.triggerTrackingEvent)(element, elementCTA, "Navigated to ".concat(result), windowId);
};

var Button = function Button(_ref) {
  var windowId = _ref.windowId,
      target = _ref.target,
      url = _ref.url,
      isClickableDivElement = _ref.isClickableDivElement,
      enableDialogWindow = _ref.enableDialogWindow,
      dialogWindowWidth = _ref.dialogWindowWidth,
      dialogWindowTitleText = _ref.dialogWindowTitleText,
      buttonTransitionProperty = _ref.buttonTransitionProperty,
      buttonTransitionTimingFunction = _ref.buttonTransitionTimingFunction,
      buttonTransitionDuration = _ref.buttonTransitionDuration,
      showButton = _ref.showButton,
      buttonText = _ref.buttonText,
      buttonStyle = _ref.buttonStyle,
      buttonSize = _ref.buttonSize,
      buttonMargin = _ref.buttonMargin,
      buttonAlignment = _ref.buttonAlignment;

  if (showButton && url && buttonText !== '') {
    return _react.default.createElement("a", {
      className: (0, _classes.setClassNames)('btn', enableDialogWindow ? 'dialog' : null, buttonStyle, buttonSize, buttonMargin, buttonAlignment, buttonTransitionProperty, buttonTransitionTimingFunction, buttonTransitionDuration),
      target: target || null,
      id: "".concat(windowId, "-button"),
      href: url,
      "data-modal": enableDialogWindow ? 'true' : null,
      "data-title": enableDialogWindow && dialogWindowTitleText ? dialogWindowTitleText : null,
      "data-width": enableDialogWindow && dialogWindowWidth ? dialogWindowWidth : null,
      onClick: function onClick(event) {
        handleClick(event, isClickableDivElement, 'ws-content-cta button', buttonText, url, windowId);
      }
    }, buttonText);
  }

  return null;
};

Button.defaultProps = {
  target: '',
  enableDialogWindow: false,
  dialogWindowWidth: '',
  dialogWindowTitleText: '',
  buttonTransitionProperty: '',
  buttonTransitionTimingFunction: '',
  buttonTransitionDuration: '',
  buttonStyle: '',
  buttonSize: '',
  buttonMargin: '',
  buttonAlignment: ''
};
Button.propTypes = {
  windowId: _propTypes.default.string.isRequired,
  target: _propTypes.default.string,
  url: _propTypes.default.string.isRequired,
  isClickableDivElement: _propTypes.default.bool.isRequired,
  enableDialogWindow: _propTypes.default.bool,
  dialogWindowWidth: _propTypes.default.string,
  dialogWindowTitleText: _propTypes.default.string,
  buttonTransitionProperty: _propTypes.default.string,
  buttonTransitionTimingFunction: _propTypes.default.string,
  buttonTransitionDuration: _propTypes.default.string,
  showButton: _propTypes.default.bool.isRequired,
  buttonText: _propTypes.default.string.isRequired,
  buttonStyle: _propTypes.default.string,
  buttonSize: _propTypes.default.string,
  buttonMargin: _propTypes.default.string,
  buttonAlignment: _propTypes.default.string
};
var _default = Button;
exports.default = _default;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classes = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Content = function Content(_ref) {
  var showContent = _ref.showContent,
      contentText = _ref.contentText,
      contentSize = _ref.contentSize,
      contentColor = _ref.contentColor,
      contentMargin = _ref.contentMargin,
      contentPadding = _ref.contentPadding,
      contentAlignment = _ref.contentAlignment,
      contentTransitionProperty = _ref.contentTransitionProperty,
      contentTransitionTimingFunction = _ref.contentTransitionTimingFunction,
      contentTransitionDuration = _ref.contentTransitionDuration;

  if (showContent && contentText !== '') {
    return _react.default.createElement("p", {
      className: (0, _classes.setClassNames)(contentSize, contentColor, contentMargin, contentPadding, contentAlignment, contentTransitionProperty, contentTransitionTimingFunction, contentTransitionDuration)
    }, contentText);
  }

  return null;
};

Content.defaultProps = {
  contentSize: '',
  contentColor: '',
  contentMargin: '',
  contentPadding: '',
  contentAlignment: '',
  contentTransitionProperty: '',
  contentTransitionTimingFunction: '',
  contentTransitionDuration: ''
};
Content.propTypes = {
  showContent: _propTypes.default.bool.isRequired,
  contentText: _propTypes.default.string.isRequired,
  contentSize: _propTypes.default.string,
  contentColor: _propTypes.default.string,
  contentMargin: _propTypes.default.string,
  contentPadding: _propTypes.default.string,
  contentAlignment: _propTypes.default.string,
  contentTransitionProperty: _propTypes.default.string,
  contentTransitionTimingFunction: _propTypes.default.string,
  contentTransitionDuration: _propTypes.default.string
};
var _default = Content;
exports.default = _default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Icon = _interopRequireDefault(__webpack_require__(18));

var _Background = _interopRequireDefault(__webpack_require__(5));

var _Heading = _interopRequireDefault(__webpack_require__(17));

var _Content = _interopRequireDefault(__webpack_require__(15));

var _Button = _interopRequireDefault(__webpack_require__(14));

var _classes = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentWrapper = function ContentWrapper(_ref) {
  var widgetConfiguration = _ref.widgetConfiguration,
      windowId = _ref.windowId,
      isClickableDivElement = _ref.isClickableDivElement,
      headingText = _ref.headingText,
      contentText = _ref.contentText,
      buttonText = _ref.buttonText,
      dialogWindowTitleText = _ref.dialogWindowTitleText,
      target = _ref.target;
  var widgetAlignment = widgetConfiguration.widgetAlignment,
      widgetJustify = widgetConfiguration.widgetJustify,
      widgetMargin = widgetConfiguration.widgetMargin,
      widgetPadding = widgetConfiguration.widgetPadding,
      textAlignment = widgetConfiguration.textAlignment,
      contentWrapperWidth = widgetConfiguration.contentWrapperWidth,
      contentWrapperTransitionProperty = widgetConfiguration.contentWrapperTransitionProperty,
      contentWrapperTransitionTimingFunction = widgetConfiguration.contentWrapperTransitionTimingFunction,
      contentWrapperTransitionDuration = widgetConfiguration.contentWrapperTransitionDuration,
      buttonTransitionProperty = widgetConfiguration.buttonTransitionProperty,
      buttonTransitionTimingFunction = widgetConfiguration.buttonTransitionTimingFunction,
      buttonTransitionDuration = widgetConfiguration.buttonTransitionDuration,
      textColor = widgetConfiguration.textColor,
      imageLocation = widgetConfiguration.imageLocation,
      enableContentOverflowHidden = widgetConfiguration.enableContentOverflowHidden;
  return _react.default.createElement("div", {
    className: (0, _classes.setClassNames)('cta-content', 'd-flex', 'flex-column', 'h-100', 'position-relative', widgetAlignment, widgetJustify, widgetMargin, widgetPadding, textAlignment, textColor, contentWrapperWidth, contentWrapperTransitionProperty, contentWrapperTransitionTimingFunction, contentWrapperTransitionDuration),
    style: enableContentOverflowHidden ? {
      overflow: 'hidden'
    } : null
  }, _react.default.createElement(_Icon.default, widgetConfiguration), imageLocation === 'foreground' && _react.default.createElement(_Background.default, widgetConfiguration), _react.default.createElement(_Heading.default, _objectSpread({}, widgetConfiguration, {
    windowId: windowId,
    headingText: headingText
  })), _react.default.createElement(_Content.default, _objectSpread({}, widgetConfiguration, {
    contentText: contentText
  })), _react.default.createElement(_Button.default, _objectSpread({}, widgetConfiguration, {
    windowId: windowId,
    isClickableDivElement: isClickableDivElement,
    target: target,
    dialogWindowTitleText: dialogWindowTitleText,
    buttonText: buttonText,
    buttonTransitionProperty: buttonTransitionProperty,
    buttonTransitionTimingFunction: buttonTransitionTimingFunction,
    buttonTransitionDuration: buttonTransitionDuration
  })));
};

ContentWrapper.defaultProps = {
  headingText: '',
  contentText: '',
  buttonText: '',
  dialogWindowTitleText: ''
};
ContentWrapper.propTypes = {
  widgetConfiguration: _propTypes.default.shape({
    widgetAlignment: _propTypes.default.string,
    widgetJustify: _propTypes.default.string,
    widgetMargin: _propTypes.default.string,
    widgetPadding: _propTypes.default.string,
    textAlignment: _propTypes.default.string,
    contentWrapperWidth: _propTypes.default.string.isRequired,
    contentWrapperTransitionProperty: _propTypes.default.string.isRequired,
    contentWrapperTransitionTimingFunction: _propTypes.default.string.isRequired,
    contentWrapperTransitionDuration: _propTypes.default.string.isRequired,
    buttonTransitionProperty: _propTypes.default.string.isRequired,
    buttonTransitionTimingFunction: _propTypes.default.string.isRequired,
    buttonTransitionDuration: _propTypes.default.string.isRequired,
    textColor: _propTypes.default.string.isRequired,
    imageLocation: _propTypes.default.string,
    enableContentOverflowHidden: _propTypes.default.bool.isRequired
  }).isRequired,
  windowId: _propTypes.default.string.isRequired,
  isClickableDivElement: _propTypes.default.bool.isRequired,
  target: _propTypes.default.string.isRequired,
  headingText: _propTypes.default.string,
  contentText: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  dialogWindowTitleText: _propTypes.default.string
};
var _default = ContentWrapper;
exports.default = _default;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classes = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading = function Heading(_ref) {
  var showHeading = _ref.showHeading,
      headingText = _ref.headingText,
      headingMargin = _ref.headingMargin,
      headingPadding = _ref.headingPadding,
      headingAlignment = _ref.headingAlignment,
      headingElement = _ref.headingElement,
      headingSize = _ref.headingSize,
      headingColor = _ref.headingColor,
      headingClasses = _ref.headingClasses,
      headingTransitionProperty = _ref.headingTransitionProperty,
      headingTransitionTimingFunction = _ref.headingTransitionTimingFunction,
      headingTransitionDuration = _ref.headingTransitionDuration,
      windowId = _ref.windowId;

  if (showHeading && headingText !== '') {
    var HeadingElement = headingElement;
    return _react.default.createElement(HeadingElement, {
      className: (0, _classes.setClassNames)(headingClasses, headingSize, headingColor, headingMargin, headingPadding, headingAlignment, headingTransitionProperty, headingTransitionTimingFunction, headingTransitionDuration),
      id: "".concat(windowId, "-heading")
    }, headingText);
  }

  return null;
};

Heading.defaultProps = {
  headingMargin: '',
  headingPadding: '',
  headingAlignment: '',
  headingElement: '',
  headingSize: '',
  headingColor: '',
  headingClasses: '',
  headingTransitionProperty: '',
  headingTransitionTimingFunction: '',
  headingTransitionDuration: ''
};
Heading.propTypes = {
  showHeading: _propTypes.default.bool.isRequired,
  headingText: _propTypes.default.string.isRequired,
  headingMargin: _propTypes.default.string,
  headingPadding: _propTypes.default.string,
  headingAlignment: _propTypes.default.string,
  headingElement: _propTypes.default.string,
  headingSize: _propTypes.default.string,
  headingColor: _propTypes.default.string,
  headingClasses: _propTypes.default.string,
  headingTransitionProperty: _propTypes.default.string,
  headingTransitionTimingFunction: _propTypes.default.string,
  headingTransitionDuration: _propTypes.default.string,
  windowId: _propTypes.default.string.isRequired
};
var _default = Heading;
exports.default = _default;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classes = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(_ref) {
  var showIcon = _ref.showIcon,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      iconColor = _ref.iconColor,
      iconMargin = _ref.iconMargin,
      iconPadding = _ref.iconPadding,
      iconAlignment = _ref.iconAlignment;

  if (showIcon && iconName !== '') {
    return _react.default.createElement("i", {
      className: (0, _classes.setClassNames)('ddc-icon', 'line-height-reset', iconName, iconSize, iconColor, iconMargin, iconPadding, iconAlignment)
    });
  }

  return null;
};

Icon.defaultProps = {
  iconSize: '',
  iconColor: '',
  iconMargin: '',
  iconPadding: '',
  iconAlignment: ''
};
Icon.propTypes = {
  showIcon: _propTypes.default.bool.isRequired,
  iconName: _propTypes.default.string.isRequired,
  iconSize: _propTypes.default.string,
  iconColor: _propTypes.default.string,
  iconMargin: _propTypes.default.string,
  iconPadding: _propTypes.default.string,
  iconAlignment: _propTypes.default.string
};
var _default = Icon;
exports.default = _default;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = __webpack_require__(11);

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(4);

var _Background = _interopRequireDefault(__webpack_require__(5));

var _ContentWrapper = _interopRequireDefault(__webpack_require__(16));

var _hover = __webpack_require__(13);

var _classes = __webpack_require__(2);

var _configuration = __webpack_require__(26);

var _analytics = __webpack_require__(6);

__webpack_require__(40);

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var setWrapperClassNames = function setWrapperClassNames(enableClickable, isHovered, imageLocation) {
  for (var _len = arguments.length, classes = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    classes[_key - 3] = arguments[_key];
  }

  var classNames = ['cta', 'd-flex', 'position-relative'].concat(classes);

  if (imageLocation === 'background-right' || imageLocation === 'background-left') {
    classNames.push('flex-row');

    if (imageLocation === 'background-right') {
      classNames.push('flex-row-reverse');
    }
  } else {
    classNames.push('flex-column');
  }

  if (enableClickable) {
    classNames.push('pointer', 'text-no-decoration');

    if (isHovered) {
      classNames.push('hover');
    }
  }

  return _classes.setClassNames.apply(_this, classNames);
};

var setStyles = function setStyles() {
  var widgetHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var styles = {};

  if (widgetHeight) {
    styles.height = widgetHeight;
  }

  return styles;
};

var handleClick = function handleClick(event, url, enableOpenNewWindow, elementCTA, windowId, isClickableModal) {
  event.preventDefault();
  (0, _analytics.triggerTrackingEvent)('ws-content-cta Call to action', elementCTA, "Navigated to ".concat(url), windowId);

  if (!isClickableModal) {
    if (enableOpenNewWindow) {
      window.open(url);
    } else {
      window.location.href = url;
    }
  }
};

var WidgetContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetContainer, _React$Component);

  function WidgetContainer() {
    _classCallCheck(this, WidgetContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(WidgetContainer).apply(this, arguments));
  }

  _createClass(WidgetContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var prefs = _ref.prefs,
              labels = _ref.labels,
              sitemap = _ref.sitemap;
          var displayStyle = prefs.displayStyle;
          var _this2$props$widgetIn = _this2.props.widgetInfo,
              deviceType = _this2$props$widgetIn.deviceType,
              windowId = _this2$props$widgetIn.windowId;
          var isHovered = _this2.props.hover.isHovered;
          var widgetConfiguration = (0, _configuration.setWidgetConfiguration)(deviceType, isHovered, displayStyle, prefs, sitemap);
          var widgetHeight = widgetConfiguration.widgetHeight,
              dialogWindowWidth = widgetConfiguration.dialogWindowWidth,
              enableDialogWindow = widgetConfiguration.enableDialogWindow,
              enableOpenNewWindow = widgetConfiguration.enableOpenNewWindow,
              enableClickable = widgetConfiguration.enableClickable,
              url = widgetConfiguration.url,
              showButton = widgetConfiguration.showButton,
              imageLocation = widgetConfiguration.imageLocation,
              headingLabel = widgetConfiguration.headingLabel,
              contentLabel = widgetConfiguration.contentLabel,
              buttonLabel = widgetConfiguration.buttonLabel,
              accessibleDescription = widgetConfiguration.accessibleDescription,
              dialogWindowTitleLabel = widgetConfiguration.dialogWindowTitleLabel,
              widgetBackgroundColor = widgetConfiguration.widgetBackgroundColor,
              widgetTransitionProperty = widgetConfiguration.widgetTransitionProperty,
              widgetTransitionTimingFunction = widgetConfiguration.widgetTransitionTimingFunction,
              widgetTransitionDuration = widgetConfiguration.widgetTransitionDuration,
              backgroundWrapperWidth = widgetConfiguration.backgroundWrapperWidth;
          var isClickable = enableClickable && url !== '';
          var isAnchorElement = isClickable && !showButton;
          var isClickableDivElement = isClickable && !isAnchorElement;
          var isClickableModal = enableDialogWindow && (isClickableDivElement || isAnchorElement);
          var WidgetElement = isAnchorElement ? 'a' : 'div';
          var target = enableOpenNewWindow && !enableDialogWindow ? '_blank' : '';
          var headingText = headingLabel && labels.getHTML(headingLabel);
          var dialogWindowTitleText = labels.get(dialogWindowTitleLabel);
          var ariaLabel = labels.get(accessibleDescription);
          return _react.default.createElement(WidgetElement, {
            className: setWrapperClassNames(enableClickable, isHovered, imageLocation, widgetBackgroundColor, widgetTransitionProperty, widgetTransitionTimingFunction, widgetTransitionDuration, isClickableModal ? 'dialog' : ''),
            style: setStyles(widgetHeight),
            href: isAnchorElement ? url : null,
            "aria-label": ariaLabel || null,
            "aria-labelledby": !ariaLabel ? "".concat(windowId, "-heading ").concat(windowId, "-button") : null,
            role: isClickableDivElement ? 'button' : null,
            "data-href": isClickableModal ? url : null,
            "data-modal": isClickableModal ? 'true' : null,
            "data-title": isClickableModal && dialogWindowTitleText ? dialogWindowTitleText : null,
            "data-width": isClickableModal && dialogWindowWidth ? dialogWindowWidth : null,
            target: isAnchorElement && target ? target : null,
            onClick: isClickable ? function (event) {
              return handleClick(event, url, enableOpenNewWindow, headingText, windowId, isClickableModal);
            } : null,
            onMouseEnter: function onMouseEnter() {
              return enableClickable && _this2.props.setHover(true);
            },
            onMouseLeave: function onMouseLeave() {
              return enableClickable && _this2.props.setHover(false);
            }
          }, imageLocation !== 'foreground' && _react.default.createElement("div", {
            className: backgroundWrapperWidth,
            style: {
              overflow: 'hidden'
            }
          }, _react.default.createElement(_Background.default, widgetConfiguration)), _react.default.createElement(_ContentWrapper.default, {
            widgetConfiguration: widgetConfiguration,
            windowId: windowId,
            isClickableDivElement: isClickableDivElement,
            imageLocation: imageLocation,
            headingText: headingText,
            contentText: contentLabel && labels.getHTML(contentLabel),
            buttonText: buttonLabel && labels.getHTML(buttonLabel),
            dialogWindowTitleText: dialogWindowTitleText,
            target: target
          }));
        }
      });
    }
  }]);

  return WidgetContainer;
}(_react.default.Component);

WidgetContainer.propTypes = {
  hover: _propTypes.default.shape({
    isHovered: _propTypes.default.bool.isRequired
  }).isRequired,
  setHover: _propTypes.default.func.isRequired,
  widgetInfo: _propTypes.default.shape({
    deviceType: _propTypes.default.string.isRequired,
    windowId: _propTypes.default.string.isRequired
  }).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hover: state.hover,
    widgetInfo: state.widgetInfo
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setHover: function setHover(isHovered) {
      dispatch((0, _hover.setHover)(isHovered));
    }
  };
};

var Widget = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WidgetContainer);
var _default = Widget;
exports.default = _default;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DDC_ICON_PREFIX = void 0;
var DDC_ICON_PREFIX = 'ddc-icon-';
exports.DDC_ICON_PREFIX = DDC_ICON_PREFIX;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [];
exports.default = _default;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hover;

var _types = __webpack_require__(3);

function hover() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_HOVER:
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hover = _interopRequireDefault(__webpack_require__(22));

var _widgetInfo = _interopRequireDefault(__webpack_require__(24));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = {
  hover: _hover.default,
  widgetInfo: _widgetInfo.default
};
var _default = root;
exports.default = _default;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = widgetInfo;

var _types = __webpack_require__(3);

function widgetInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_WIDGET_INFO:
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBackgroundStyles = exports.setBackgroundClassNames = void 0;

var _classes = __webpack_require__(2);

var _images = __webpack_require__(9);

var _this = void 0;

/**
 * Sets the background classes based on configuration parameters
 * Returns string with joined classes or null if no classes are defined
 * @param {string} imageLocation - A string value for image location (i.e. 'foreground' or 'background')
 * @param {boolean} foregroundImageCircle - A boolean value for displaying foreground image as a circle
 * @param {string} foregroundImageMargin - A string value for image margin class
 * @param {string} foregroundImagePadding - A string value for image padding class
 * @param {string} foregroundImageAlignment - A string value for image alignment class
 * @param {string} backgroundColor - A string value for background color class
 */
var setBackgroundClassNames = function setBackgroundClassNames(imageLocation, foregroundImageCircle, foregroundImageMargin, foregroundImagePadding, foregroundImageAlignment, backgroundColor) {
  for (var _len = arguments.length, classes = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
    classes[_key - 6] = arguments[_key];
  }

  var classNames = classes.concat();

  if (imageLocation === 'foreground') {
    classNames.push('cta-foreground');
    classNames.push(foregroundImageMargin);
    classNames.push(foregroundImagePadding);
    classNames.push(foregroundImageAlignment);

    if (foregroundImageCircle) {
      classNames.push('img-circle');
    }
  } else {
    classNames.push(backgroundColor);
    classNames.push('cta-background', 'h-100', 'w-100');

    if (imageLocation === 'background') {
      classNames.push('position-absolute');
    }
  }

  return _classes.setClassNames.apply(_this, classNames);
};
/**
 * Sets the background styles based on configuration parameters
 * Returns an object with all styles defined
 * @param {boolean} showImage - A boolean value for displaying image
 * @param {string} imageLocation - A string value for image location (i.e. 'foreground' or 'background')
 * @param {string} imageUrl - A string value for image URL
 * @param {string} imagePosition - A string value for background position
 * @param {string} imageSize - A string value for background size
 * @param {string} backgroundGradient - A string value for background gradient
 * @param {string} backgroundRepeat - A string value for background repeat
 * @param {number} foregroundImageHeight - A number value for height
 * @param {number} foregroundImageWidth - A number value for width
 * @param {boolean} hasResponsiveImage - A boolean value for whether image is responsive
 * @param {string} backgroundImage - A string value for background image src
 */


exports.setBackgroundClassNames = setBackgroundClassNames;

var setBackgroundStyles = function setBackgroundStyles(showImage, imageLocation, imageUrl, imagePosition, imageSize, backgroundGradient, backgroundRepeat, foregroundImageHeight, foregroundImageWidth, hasResponsiveImage, backgroundImage) {
  var styles = {};
  var backgroundImageUrl = backgroundImage;

  if (showImage) {
    if (!hasResponsiveImage) {
      backgroundImageUrl = (0, _images.setImageUrl)(imageUrl, foregroundImageHeight, foregroundImageWidth, imageLocation);
    }

    if (imagePosition) {
      styles.backgroundPosition = imagePosition;
    }

    if (imageSize) {
      styles.backgroundSize = imageSize;
    }

    if (imageLocation === 'foreground') {
      styles.flex = 'none';

      if (foregroundImageHeight) {
        styles.height = "".concat(foregroundImageHeight, "px");
      }

      if (foregroundImageWidth) {
        styles.width = "".concat(foregroundImageWidth, "px");
      }

      if (imageUrl) {
        styles.backgroundImage = "url('".concat(backgroundImageUrl, "')");
        styles.backgroundRepeat = 'no-repeat';
      }
    } else {
      if (backgroundGradient && imageUrl) {
        styles.backgroundImage = "".concat(backgroundGradient, ", url('").concat(backgroundImageUrl, "')");
      } else if (backgroundGradient) {
        styles.backgroundImage = backgroundGradient;
      } else if (imageUrl) {
        styles.backgroundImage = "url('".concat(backgroundImageUrl, "')");
      }

      if (backgroundRepeat) {
        styles.backgroundRepeat = backgroundRepeat;
      }
    }
  } else if (backgroundGradient) {
    styles.backgroundImage = backgroundGradient;
  }

  return styles;
};

exports.setBackgroundStyles = setBackgroundStyles;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setWidgetConfiguration = void 0;

var _format = __webpack_require__(27);

var _images = __webpack_require__(8);

var _hover = __webpack_require__(28);

var _links = __webpack_require__(29);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Sets the configuration object for the widget
 * Returns a new object based on widget display logic conditions
 * @param {string} deviceType - The request data device ('MOBILE', 'DESKTOP')
 * @param {boolean} isHovered - The hover event of the entire app
 * @param {string} displayStyle - The display style of the widget
 * @param {object} prefs - The preferences object
 * @param {object} sitemap - The sitemap object
 */
var setWidgetConfiguration = function setWidgetConfiguration(deviceType, isHovered, displayStyle) {
  var prefs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var sitemap = arguments.length > 4 ? arguments[4] : undefined;
  var trimmedPrefs = (0, _format.trimObj)(prefs);

  var formattedConfiguration = _objectSpread({}, trimmedPrefs, {
    enableClickable: (0, _format.toBoolean)(trimmedPrefs.enableClickable),
    enableOpenNewWindow: (0, _format.toBoolean)(trimmedPrefs.enableOpenNewWindow),
    enableDialogWindow: (0, _format.toBoolean)(trimmedPrefs.enableDialogWindow),
    showIcon: (0, _format.toBoolean)(trimmedPrefs.showIcon),
    showImage: (0, _format.toBoolean)(trimmedPrefs.showImage),
    showHeading: (0, _format.toBoolean)(trimmedPrefs.showHeading),
    showContent: (0, _format.toBoolean)(trimmedPrefs.showContent),
    showButton: (0, _format.toBoolean)(trimmedPrefs.showButton),
    foregroundImageCircle: (0, _format.toBoolean)(trimmedPrefs.foregroundImageCircle),
    foregroundImageHeight: (0, _format.toInt)(trimmedPrefs.foregroundImageHeight),
    foregroundImageWidth: (0, _format.toInt)(trimmedPrefs.foregroundImageWidth),
    iconName: (0, _format.toIcon)(trimmedPrefs.iconName)
  });

  var defaultConfiguration = _objectSpread({}, formattedConfiguration, {
    enableContentOverflowHidden: true,
    url: (0, _links.setUrl)(sitemap, formattedConfiguration.url),
    backgroundWrapperWidth: 'w-100',
    contentWrapperWidth: 'w-100',
    headingElement: formattedConfiguration.headingElement || 'h2',
    headingClasses: '',
    buttonAlignment: formattedConfiguration.widgetAlignment ? null : 'align-self-start',
    foregroundImageHeight: (0, _images.setImageDimension)('height', deviceType, formattedConfiguration.foregroundImageHeight, formattedConfiguration.foregroundImageWidth, formattedConfiguration.foregroundImageCircle),
    foregroundImageWidth: (0, _images.setImageDimension)('width', deviceType, formattedConfiguration.foregroundImageHeight, formattedConfiguration.foregroundImageWidth, formattedConfiguration.foregroundImageCircle),
    widgetTransitionProperty: 'transition-property-background-color transition-property-text-color',
    widgetTransitionTimingFunction: 'transition-timing-function-standard',
    widgetTransitionDuration: 'transition-duration-lg',
    backgroundTransitionProperty: 'transition-property-background-color',
    backgroundTransitionTimingFunction: 'transition-timing-function-standard',
    backgroundTransitionDuration: 'transition-duration-lg',
    headingTransitionProperty: '',
    headingTransitionTimingFunction: '',
    headingTransitionDuration: '',
    contentWrapperTransitionProperty: '',
    contentWrapperTransitionTimingFunction: '',
    contentWrapperTransitionDuration: '',
    buttonTransitionProperty: '',
    buttonTransitionTimingFunction: '',
    buttonTransitionDuration: '',
    contentTransitionProperty: '',
    contentTransitionTimingFunction: '',
    contentTransitionDuration: ''
  });

  var hoverConfiguration = {
    widgetBackgroundColor: (0, _hover.setHoverValue)(isHovered, defaultConfiguration.widgetBackgroundColorHover, defaultConfiguration.widgetBackgroundColor),
    textColor: (0, _hover.setHoverValue)(isHovered, defaultConfiguration.textColorHover, defaultConfiguration.textColor),
    backgroundColor: (0, _hover.setHoverValue)(isHovered, defaultConfiguration.backgroundColorHover, defaultConfiguration.backgroundColor),
    backgroundGradient: (0, _hover.setHoverValue)(isHovered, defaultConfiguration.backgroundGradientHover, defaultConfiguration.backgroundGradient)
  };
  var displayStyleConfiguration = {
    widgetAlignment: 'align-items-center',
    widgetJustify: '',
    widgetMargin: '',
    widgetPadding: 'p-5',
    enableClickable: false,
    showIcon: false,
    showImage: true,
    showHeading: true,
    showContent: true,
    showButton: true,
    textAlignment: 'text-center',
    imageLocation: 'background',
    backgroundColor: '',
    backgroundColorHover: '',
    backgroundGradient: '',
    backgroundGradientHover: '',
    iconMargin: '',
    iconPadding: '',
    iconAlignment: '',
    foregroundImageMargin: '',
    foregroundImagePadding: '',
    foregroundImageAlignment: '',
    foregroundImageCircle: false,
    headingPadding: '',
    headingAlignment: '',
    headingMargin: 'mt-0',
    contentMargin: '',
    contentPadding: '',
    contentAlignment: '',
    buttonAlignment: 'align-self-center',
    buttonMargin: ''
  };

  switch (displayStyle) {
    case 'icon-heading-content-cta-centered':
      return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, {
        widgetJustify: 'justify-content-center',
        imageUrl: '',
        showIcon: true,
        iconMargin: 'm-0',
        headingMargin: 'mt-6 mx-0 mb-4',
        contentMargin: 'mt-0 mx-0 mb-4',
        buttonMargin: 'm-0'
      });

    case 'image-heading-content-cta-centered':
      return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, {
        widgetJustify: 'justify-content-center',
        imageLocation: 'foreground',
        foregroundImageCircle: true,
        foregroundImageHeight: (0, _images.setImageDimension)('height', deviceType, formattedConfiguration.foregroundImageHeight, formattedConfiguration.foregroundImageWidth, true),
        foregroundImageWidth: (0, _images.setImageDimension)('width', deviceType, formattedConfiguration.foregroundImageHeight, formattedConfiguration.foregroundImageWidth, true),
        foregroundImageMargin: 'mt-0 mx-0 mb-5',
        headingMargin: 'mt-0 mx-0 mb-4',
        contentMargin: 'mt-0 mx-0 mb-4',
        buttonMargin: 'm-0'
      });

    case 'background-image-zoom-heading':
      {
        var backgroundTransitionConfiguration = deviceType === 'DESKTOP' ? {
          backgroundTransitionProperty: "transition-property-transform scale-".concat(isHovered ? '110' : '100'),
          backgroundTransitionTimingFunction: 'transition-timing-function-standard',
          backgroundTransitionDuration: 'transition-duration-xl'
        } : null;
        return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, backgroundTransitionConfiguration, {
          enableClickable: true,
          showContent: false,
          showButton: false,
          headingMargin: 'mt-auto mb-0',
          headingColor: 'text-white',
          backgroundColor: 'bg-black',
          backgroundGradient: 'linear-gradient(rgba(0,0,0,0) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,.6) 100%)'
        });
      }

    case 'background-image-zoom-icon-heading':
      {
        var _backgroundTransitionConfiguration = deviceType === 'DESKTOP' ? {
          backgroundTransitionProperty: "transition-property-transform scale-".concat(isHovered ? '110' : '100'),
          backgroundTransitionTimingFunction: 'transition-timing-function-standard',
          backgroundTransitionDuration: 'transition-duration-xl'
        } : null;

        return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, _backgroundTransitionConfiguration, {
          widgetJustify: 'justify-content-center',
          enableClickable: true,
          showContent: false,
          showIcon: true,
          showButton: false,
          iconSize: defaultConfiguration.iconSize || 'icon-size-7',
          iconColor: defaultConfiguration.iconColor || 'text-primary-300',
          headingMargin: 'mt-3 mx-0 mb-0',
          headingColor: defaultConfiguration.headingColor || 'text-white',
          backgroundColor: defaultConfiguration.backgroundColor || 'bg-black',
          backgroundGradient: defaultConfiguration.backgroundGradient || 'linear-gradient(rgba(0,0,0,.6) 0%, rgba(0,0,0,.6) 100%)'
        });
      }

    case 'heading-left-image-right-zoom':
      {
        var _backgroundTransitionConfiguration2 = deviceType === 'DESKTOP' ? {
          backgroundTransitionProperty: "transition-property-transform scale-".concat(isHovered ? '105' : '100'),
          backgroundTransitionTimingFunction: 'transition-timing-function-standard',
          backgroundTransitionDuration: 'transition-duration-xl'
        } : null;

        return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, _backgroundTransitionConfiguration2, {
          widgetJustify: 'justify-content-center',
          widgetBackgroundColor: isHovered ? defaultConfiguration.widgetBackgroundColorHover || 'bg-light' : defaultConfiguration.widgetBackgroundColor || '',
          enableClickable: true,
          showContent: false,
          showButton: false,
          backgroundWrapperWidth: 'w-50',
          contentWrapperWidth: 'w-50',
          imageLocation: 'background-left',
          textColor: isHovered ? defaultConfiguration.textColorHover || 'text-primary' : defaultConfiguration.textColor || 'text-body',
          headingClasses: 'centered-border-bottom-sm',
          headingMargin: 'm-0',
          headingTransitionProperty: "transition-property-after-transform scale-after-".concat(isHovered ? '150-100' : '100'),
          headingTransitionTimingFunction: 'transition-timing-function-after-standard',
          headingTransitionDuration: 'transition-duration-after-md'
        });
      }

    case 'image-left-zoom-heading-right':
      {
        var _backgroundTransitionConfiguration3 = deviceType === 'DESKTOP' ? {
          backgroundTransitionProperty: "transition-property-transform scale-".concat(isHovered ? '105' : '100'),
          backgroundTransitionTimingFunction: 'transition-timing-function-standard',
          backgroundTransitionDuration: 'transition-duration-xl'
        } : null;

        return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, _backgroundTransitionConfiguration3, {
          widgetJustify: 'justify-content-center',
          widgetBackgroundColor: isHovered ? defaultConfiguration.widgetBackgroundColorHover || 'bg-light' : defaultConfiguration.widgetBackgroundColor || '',
          enableClickable: true,
          showContent: false,
          showButton: false,
          backgroundWrapperWidth: 'w-50',
          contentWrapperWidth: 'w-50',
          imageLocation: 'background-right',
          textColor: isHovered ? defaultConfiguration.textColorHover || 'text-primary' : defaultConfiguration.textColor || 'text-body',
          headingClasses: 'centered-border-bottom-sm',
          headingMargin: 'm-0',
          headingTransitionProperty: "transition-property-after-transform scale-after-".concat(isHovered ? '150-100' : '100'),
          headingTransitionTimingFunction: 'transition-timing-function-after-standard',
          headingTransitionDuration: 'transition-duration-after-md'
        });
      }

    case 'background-zoom-hover-rollup':
      {
        var _backgroundTransitionConfiguration4 = deviceType === 'DESKTOP' ? {
          backgroundTransitionProperty: "transition-property-transform scale-".concat(isHovered ? '110' : '100'),
          backgroundTransitionTimingFunction: 'transition-timing-function-standard',
          backgroundTransitionDuration: 'transition-duration-xl'
        } : null;

        var rollupConfiguration;

        if (deviceType === 'DESKTOP') {
          rollupConfiguration = {
            contentWrapperTransitionProperty: isHovered ? 'translate-up-10' : 'translate-down-0',
            buttonTransitionProperty: isHovered ? 'opacity-100' : 'opacity-0',
            widgetPadding: 'p-0',
            headingColor: 'text-white',
            headingMargin: 'm-2',
            buttonSize: 'btn-xsmall',
            buttonMargin: isHovered ? 'mt-4' : 'mt-3'
          };
        } else {
          rollupConfiguration = {
            contentTransitionProperty: 'opacity-0',
            buttonTransitionProperty: 'opacity-100',
            showContent: false,
            widgetPadding: 'p-6',
            headingColor: 'text-white',
            headingMargin: 'm-4',
            buttonSize: 'btn-small'
          };
        }

        return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, _backgroundTransitionConfiguration4, rollupConfiguration, {
          contentWrapperTransitionTimingFunction: 'transition-timing-function-standard',
          contentWrapperTransitionDuration: 'transition-duration-xl',
          buttonTransitionTimingFunction: 'transition-timing-function-standard',
          buttonTransitionDuration: 'transition-duration-xl',
          enableClickable: true,
          showButton: true,
          buttonStyle: 'btn-default btn-inverse',
          contentColor: 'text-white',
          contentMargin: 'm-0',
          widgetJustify: 'justify-content-end',
          contentSize: 'h4',
          backgroundColor: 'bg-black',
          backgroundGradient: 'linear-gradient(rgba(0,0,0,0) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,.6) 100%)'
        });
      }

    default:
      return _objectSpread({}, defaultConfiguration, hoverConfiguration);
  }
};

exports.setWidgetConfiguration = setWidgetConfiguration;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toIcon = exports.toInt = exports.toBoolean = exports.trimObj = void 0;

var _globalConstants = __webpack_require__(20);

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Trims the values in a flat object property
 * Returns an empty object if the argument is an empty object
 * @param {object} obj - A flat 'key: value' object
 */
var trimObj = function trimObj() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== null && _typeof(obj[key]) === 'object') {
      throw new Error("The property '".concat(key, "' is of type 'Object' that cannot be trimmed"));
    }

    acc[key] = obj[key].trim();
    return acc;
  }, {});
};
/**
 * Converts a string to a boolean value
 * Returns a boolean value with a default value of false
 * @param {string} value - A string value of "true" or "false"
 */


exports.trimObj = trimObj;

var toBoolean = function toBoolean() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value.toLowerCase().trim() === 'true';
};
/**
 * Converts a string to an integer value
 * Returns an integer
 * @param {string} value - A string value to be converted to an integer
 */


exports.toBoolean = toBoolean;

var toInt = function toInt() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return parseInt(value, 10) || 0;
};
/**
 * Converts a string to a `ddc-icon-` prefaced string value
 * Returns a string
 * @param {string} iconName - A string value to be converted to a DDC icon class
 */


exports.toInt = toInt;

var toIcon = function toIcon() {
  var iconName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return iconName && (iconName.indexOf(_globalConstants.DDC_ICON_PREFIX) === 0 ? iconName : "".concat(_globalConstants.DDC_ICON_PREFIX).concat(iconName));
};

exports.toIcon = toIcon;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHoverValue = void 0;

/**
 * Sets a value based on boolean param value
 * Returns a string value if hover state and hover value is present or
 * else it will return an empty string
 * @param {boolean} isHovered - A boolean value dictating returned value
 * @param {string} hoverValue - A string value for hover display state
 * @param {string} defaultValue - A string value for default display state
 */
var setHoverValue = function setHoverValue() {
  var isHovered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var hoverValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return isHovered && hoverValue ? hoverValue : defaultValue;
};

exports.setHoverValue = setHoverValue;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUrl = exports.determineUrlType = exports.isStringAbsoluteUrl = exports.isStringAlias = void 0;

/**
 * Checks if the string is valid sitemap entry alias eg: uppercase and underscores
 * @param {string} str - A string that is checked against
 */
var isStringAlias = function isStringAlias() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var r = new RegExp('^[A-Z0-9_]+$', 'g');
  return r.test(str);
};
/**
 * Determines if the string passed in is an absolute url
 * @param {string} str - A string that is checked against
 */


exports.isStringAlias = isStringAlias;

var isStringAbsoluteUrl = function isStringAbsoluteUrl() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var r = new RegExp('^(?:[a-z]+:)?//', 'i');
  return r.test(str);
};
/**
 * Determines the url type passed in either as ALIAS, ABSOLUTE or RELATIVE
 * @param {string} url - A string value with a URL string or page alias
 */


exports.isStringAbsoluteUrl = isStringAbsoluteUrl;

var determineUrlType = function determineUrlType() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (isStringAlias(url)) {
    return 'ALIAS';
  } else if (isStringAbsoluteUrl(url)) {
    return 'ABSOLUTE';
  } else {
    return 'RELATIVE';
  }
};
/**
 * Sets the URL string based on sitemap request
 * Returns a string value after requesting a path from the sitemap service
 * @param {object} sitemap - An object containing helper functions for sitemap entries
 * @param {string} url - A string value with a URL string or page alias
 */


exports.determineUrlType = determineUrlType;

var setUrl = function setUrl(sitemap) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  switch (determineUrlType(url)) {
    case 'ALIAS':
      return sitemap.has(url) ? sitemap.get(url) : '/404.htm';

    default:
      return url || '/404.htm';
  }
};

exports.setUrl = setUrl;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackGoogleAnalyticsEvent = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Triggers a tracking event using data from widget
 * Returns a tracking object within a triggered `trackEvent` event
 * Refer to https://fuel.coxautoinc.com/docs/DOC-144882 for usage and defaults
 * @param {object} eventData - An object containing event data
 */
var trackGoogleAnalyticsEvent = function trackGoogleAnalyticsEvent(eventData, window) {
  var trackingObject = _typeof(window) === 'object' ? window.jQuery(document) : {};
  var defaultClickEvent = {
    event: 'widgetUserEvent',
    action: 'clicked',
    widgetState: 'default',
    fieldValue: undefined,
    formId: undefined,
    formEventId: undefined,
    value: undefined,
    widgetName: 'ws-content-cta'
  };

  if (Object.keys(trackingObject).length > 0) {
    return trackingObject.trigger('trackEvent', _objectSpread({}, defaultClickEvent, eventData));
  }

  return null;
};

exports.trackGoogleAnalyticsEvent = trackGoogleAnalyticsEvent;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collapse = function Collapse(props) {
  var id = props.id,
      children = props.children,
      toggleCollapse = props.toggleCollapse;

  if (toggleCollapse) {
    return _react.default.createElement("div", {
      id: "".concat(id, "-collapse"),
      className: "collapse collapse-content"
    }, children);
  }

  return children;
};

Collapse.propTypes = {
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.element.isRequired,
  toggleCollapse: _propTypes.default.bool
};
Collapse.defaultProps = {
  toggleCollapse: false
};
var _default = Collapse;
exports.default = _default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// eslint-disable-line import/no-unresolved
var WidgetHeading =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetHeading, _React$Component);

  function WidgetHeading(props) {
    var _this;

    _classCallCheck(this, WidgetHeading);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetHeading).call(this, props));
    _this.renderDelegate = _this.renderDelegate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetHeading, [{
    key: "renderDelegate",
    value: function renderDelegate(_ref) {
      var labels = _ref.labels;
      var _this$props = this.props,
          HeadingTag = _this$props.HeadingTag,
          headingText = _this$props.headingText,
          widgetId = _this$props.widgetId,
          toggleCollapse = _this$props.toggleCollapse,
          showIcon = _this$props.showIcon,
          headingClasses = _this$props.headingClasses,
          iconClasses = _this$props.iconClasses;

      var allIconClasses = _toConsumableArray(iconClasses);

      var collapseAttributes = {};

      if (toggleCollapse) {
        var iconExpand = 'ddc-icon-expand';
        allIconClasses.push(iconExpand);
        allIconClasses.push('icon-style-collapse');
        collapseAttributes = {
          role: 'button',
          'data-toggle': 'collapse',
          'data-target': "#".concat(widgetId, "-collapse"),
          'data-expand-icon-class': "".concat(iconExpand),
          'data-collapse-icon-class': 'ddc-icon-collapse',
          'aria-expanded': 'false',
          'aria-controls': "".concat(widgetId, "-collapse")
        };
      }

      return _react.default.createElement(HeadingTag, _extends({
        className: headingClasses.join(' ')
      }, collapseAttributes), showIcon && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("i", {
        className: allIconClasses.join(' ')
      }), ' '), labels.getHTML(headingText));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.headingText || this.props.headingText.toUpperCase() === 'FALSE') {
        return null;
      } else {
        return _react.default.createElement(_common.Common, {
          render: this.renderDelegate
        });
      }
    }
  }]);

  return WidgetHeading;
}(_react.default.Component);

WidgetHeading.propTypes = {
  HeadingTag: _propTypes.default.string,
  headingText: _propTypes.default.string,
  widgetId: _propTypes.default.string.isRequired,
  toggleCollapse: _propTypes.default.bool.isRequired,
  showIcon: _propTypes.default.bool.isRequired,
  headingClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  iconClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
WidgetHeading.defaultProps = {
  HeadingTag: 'h3',
  headingText: ''
};
var _default = WidgetHeading;
exports.default = _default;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flags;

function flags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_FEATURE_FLAGS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = labels;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function labels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_LABELS':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefs;

function prefs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_PREFS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestData;

function requestData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_REQUEST_DATA':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sitemap;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sitemap() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_SITEMAP':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _redux = __webpack_require__(49);

var _reduxThunk = _interopRequireDefault(__webpack_require__(50));

var _reducers = _interopRequireDefault(__webpack_require__(23));

var _requestData = _interopRequireDefault(__webpack_require__(36));

var _prefs = _interopRequireDefault(__webpack_require__(35));

var _labels = _interopRequireDefault(__webpack_require__(34));

var _sitemap = _interopRequireDefault(__webpack_require__(37));

var _flags = _interopRequireDefault(__webpack_require__(33));

var _middleware = _interopRequireDefault(__webpack_require__(21));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-line import/no-unresolved
var providedReducers = {
  requestData: _requestData.default,
  prefs: _prefs.default,
  labels: _labels.default,
  sitemap: _sitemap.default,
  flags: _flags.default
};
var reducers = (0, _redux.combineReducers)(_objectSpread({}, _reducers.default, providedReducers));

var middleware = _toConsumableArray(_middleware.default).concat([_reduxThunk.default]);

var locationContains = function locationContains(search) {
  return window.location.toString().indexOf(search) !== -1;
};

var isBrowser = typeof window !== 'undefined';
var showReduxLoggerFromUrlParam = isBrowser && (locationContains('_mode=debug') || locationContains('wsScriptsUseReduxLogger=true'));

if (isBrowser && ("production" === 'development' || showReduxLoggerFromUrlParam)) {
  // Note: This must the be last middleware in the chain so that it logs actions
  // instead of thunks or Promises.
  // Use an actionTransformer to get the widget name into the output since
  // we have multiple stores running on one page. It may seem like using
  // titleFormatter makes more sense for this purpose, but doing so loses the
  // readability improvement coloring added in 2.10.0 of redux-logger. As of
  // 3.0.6, there is no way to get colors without using the default title formatter.
  // With the below action transformer and default title formatter, we get:
  // action ws-GENERIC-WIDGET-NAME - MIDDLEWARE_TEST @ 17:47:41.612 (in 0.30 ms)
  var actionTransformer = function actionTransformer(action) {
    return _objectSpread({}, action, {
      type: "ws-content-cta - ".concat(action.type)
    });
  };

  var _require = __webpack_require__(46),
      createLogger = _require.createLogger;

  var logger = createLogger({
    actionTransformer: actionTransformer,
    duration: true
  });
  middleware.push(logger);
}

var enhancer = _redux.applyMiddleware.apply(void 0, _toConsumableArray(middleware));

function createStore(initialState) {
  var store = (0, _redux.createStore)(reducers, initialState, enhancer);

  if (false) {
    module.hot.accept('../reducers', function () {
      var defaultReducers = require('../reducers').default; // eslint-disable-line import/no-unresolved


      store.replaceReducer((0, _redux.combineReducers)(_objectSpread({}, defaultReducers, providedReducers)));
    });
  }

  return store;
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetComponents = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(11);

var _WidgetHeading = _interopRequireDefault(__webpack_require__(32));

var _Collapse = _interopRequireDefault(__webpack_require__(31));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIconClasses = function getIconClasses(prefs, showIcon, toggleCollapse) {
  var iconClasses = [];
  var widgetHeading = prefs.widgetHeading,
      headingIconClasses = prefs.headingIconClasses,
      headingIconSize = prefs.headingIconSize,
      headingIconStyle = prefs.headingIconStyle;

  if (widgetHeading && showIcon) {
    iconClasses.push('ddc-icon');

    if (!toggleCollapse) {
      iconClasses.push("ddc-icon-".concat(headingIconStyle));
    }

    if (headingIconSize) {
      iconClasses.push("ddc-icon-size-".concat(headingIconSize));
    }

    if (headingIconClasses) {
      iconClasses.push(headingIconClasses);
    }
  }

  return iconClasses;
};

var getHeadingClasses = function getHeadingClasses(prefs, deviceType, toggleCollapse) {
  var headingClasses = [];
  var headingSize = prefs.headingSize,
      headingStyles = prefs.headingStyles;
  headingClasses.push('widget-heading');

  if (deviceType === 'MOBILE') {
    headingClasses.push('ddc-heading');
  }

  if (headingSize) {
    headingClasses.push(headingSize);
  }

  if (headingStyles) {
    headingClasses.push("ddc-heading-".concat(headingStyles));
  }

  if (toggleCollapse) {
    headingClasses.push('collapse-heading');
  }

  return headingClasses;
};

var getWidgetComponents = function getWidgetComponents(Widget, store, widgetId) {
  var state = store.getState();
  var prefs = state.prefs || {};
  var toggleCollapse = prefs.widgetHeading && prefs.toggleCollapse === 'true' || false;
  var showIcon = prefs.headingIconStyle ? true : toggleCollapse;
  return _react.default.createElement(_reactRedux.Provider, {
    store: store
  }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_WidgetHeading.default, {
    HeadingTag: prefs.headingTag,
    headingText: prefs.widgetHeading,
    widgetId: widgetId,
    toggleCollapse: toggleCollapse,
    showIcon: showIcon,
    headingClasses: getHeadingClasses(prefs, state.requestData.deviceType, toggleCollapse),
    iconClasses: getIconClasses(prefs, showIcon, toggleCollapse)
  }), _react.default.createElement(_Collapse.default, {
    id: widgetId,
    toggleCollapse: toggleCollapse
  }, _react.default.createElement(Widget, null))));
};

exports.getWidgetComponents = getWidgetComponents;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(44)


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(43);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(0);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(45);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(42);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = DDC.WsmCommonData;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = Redux;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = ReduxThunk;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(12);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.d28a6c7635b43604ad90.js